import { baseInquiryDetail } from '@models/BookingInquiry';
import * as t from 'io-ts';

export const bookingInquiryChangeLogField = t.union([
  t.literal('shipper'),
  t.literal('receiver'),
  t.literal('consignee'),
  t.literal('has_pickups'),
  t.literal('cargos'),
  t.literal('trade_condition'),
  t.literal('customer_no'),
  t.literal('special_note'),
  t.literal('use_trading_agency'),
  t.literal('trading_agency_payer'),
  t.literal('use_rcep'),
  t.literal('preferred_arrival_date'),
  t.literal('pickup_date'),
  t.literal('move_in_date'),
]);

export type BookingInquiryChangeLogField = t.TypeOf<typeof bookingInquiryChangeLogField>;

export const bookingInquiryChangeLogValue = t.partial(baseInquiryDetail.props);

export const bookingInquiryChangeLog = t.type({
  id: t.number,
  group_id: t.string,
  has_read: t.boolean,
  edited_field: bookingInquiryChangeLogField,
  before_value: bookingInquiryChangeLogValue,
  after_value: bookingInquiryChangeLogValue,
  created_at: t.string,
  updated_at: t.string,
});

export type BookingInquiryChangeLog = t.TypeOf<typeof bookingInquiryChangeLog>;
